const Tooltip = {
	toggle: _ => {

		let current = _.children('.tooltip').html();
		let next = _.attr('data-tooltip-toggle');

		_.attr('data-tooltip-toggle', current).children('.tooltip').html(next);

	}
}

export default Tooltip